import { Routes } from '@angular/router';
import { authGuard, authGuardChild, authMatchGuard } from './guards/auth.guard';
import { provideState } from '@ngrx/store';
import { loginFeature } from './pages/login/store/reducers';
import { provideEffects } from '@ngrx/effects';
import { LoginEffects } from './pages/login/store/effects';
import { ticketsFeature } from './pages/tickets/store/reducers';
import { TicketsEffects } from './pages/tickets/store/effects';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./pages/home/home.component').then((c) => c.HomeComponent),
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    canActivateChild: [authGuardChild],
    loadChildren: () =>
      import('./pages/home/home.routes').then((x) => x.routes),
    providers: [
      provideState(ticketsFeature),
      provideEffects(TicketsEffects),
    ],
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./pages/login/login.component').then((x) => x.LoginComponent),
    providers: [
      provideState(loginFeature),
      provideEffects(LoginEffects),
    ],
  },
  {
    path: 'integrations/connect',
    loadComponent: () =>
      import('./pages/integrations-connect/integrations-connect.component').then(
        (x) => x.IntegrationsConnectComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: 'chat',
    loadComponent: () =>
      import('./pages/chatbotwebapp/chatbotwebapp.component').then(
        (x) => x.ChatbotwebappComponent
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login',
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
